export enum TerminalType {
  Undefined,
  Entry,
  Exit,
  PassageTerminal,
  Pos,
  CountNodeSimple,
  PayStation,
  IOController,
  TicketValidationStation,
  ShowNGo,
  WebPos,
  PedestrianDoor,
  SecurityReader,
  PayAtExit,
  PosAtExit,
  Ips,
}

export interface TerminalTypeObj {
  id: number;
  name: string;
}

export interface TerminalTypeString {
  type: number;
  name: string;
}
